import { useMutation } from '@tanstack/react-query'
import { getSuitableDealersToAssign } from '../services/NewApiService'
import { getComp } from '../utils/utils/DI'

export const useLookupDealerCollection = (ids: number[], dealer?: string) => {
  const dealersStore = getComp('DealersStore')
  const {
    data,
    mutateAsync: getFittedDealers,
    isPending: isLoading,
  } = useMutation({
    mutationKey: ['get-fitted-dealers', ids],
    mutationFn: () => getSuitableDealersToAssign(ids),
  })

  const dealerOrders = dealer ? (data?.[dealer] ?? []) : []
  const dealers = dealersStore.collection.filter((el: any) =>
    data ? Object.keys(data).includes(el?.subjectId) : false,
  )

  return { data, isLoading, getFittedDealers, dealerOrders, dealers }
}
